/*global jQuery, _, Backbone, PodsMn */
export const PodsDFVFieldModel = Backbone.Model.extend( {
	defaults: {
		htmlAttr: {},
		fieldConfig: {}
	}
} );
